import { useTranslation } from 'react-i18next';
import { buttonStyle, useStyles } from './styles';
import { Box, Grid, Typography } from '@mui/material';
import { useSettingsContext } from '../../context/SettingsContext';
import { Week } from './settings.types';
import Card from './components/Card/Card';
import { useForm } from 'react-hook-form';
import Button from '../../components/Button/Button';
import { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext/AuthContext';
import { getCurrentSettings } from '../../modals/order';
import { updateDoc } from '../../libs/firestore-wrapper';
import Toast from '../../components/Toast/Toast';
import Loader from './components/Loader/Loader';
import { LANG_TEXT } from '../../constants/language';

function Settings() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { currentSetting, setCurrentSetting, loading } = useSettingsContext();
  const { userInfo } = useAuthContext();
  const toast = useRef<{ type: 'error' | 'success'; content: string }>({
    type: 'success',
    content: '',
  });
  const [openToast, setOpenToast] = useState(false);
  const { control, handleSubmit } = useForm<any>({
    defaultValues: {},
  });
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    setFormData(currentSetting.opening_schedule);
  }, [currentSetting]);

  const onSubmit = handleSubmit(async () => {
    try {
      const hasError = Object.values(errors).some((error: boolean) => error);
      if (hasError) {
        return;
      }
      await updateDoc(getCurrentSettings(userInfo.restaurant_id), {
        opening_schedule: formData,
      });

      toast.current = {
        content: t(LANG_TEXT.UPDATE_SUCCESS_MESSAGE),
        type: 'success',
      };
      setOpenToast(true);
      setCurrentSetting((prevData: any) => ({
        ...prevData,
        opening_schedule: formData,
      }));
    } catch (error) {
      toast.current = {
        content: t(LANG_TEXT.UPDATE_FAILED_MESSAGE),
        type: 'error',
      };
      setOpenToast(true);
    }
  });

  return (
    <Box
      component="main"
      className={classes.Settings}
      sx={{
        backgroundColor: (theme) => (theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900]),
      }}
    >
      <Box className={classes.BoxTitle}>
        <Typography fontSize={24} lineHeight={'32px'} fontWeight={500} color={'var(--Gray-900, #101828)'}>
          {t(LANG_TEXT.SETTINGS)}
        </Typography>
      </Box>
      {loading ? (
        <Loader />
      ) : (
        <form className={classes.Content} noValidate autoComplete="off" onSubmit={onSubmit}>
          <Box className={classes.OperatingHourSettings}>
            <Box className={classes.OperatingHourSettingsTitle}>
              <Typography fontSize={16} fontWeight={500} lineHeight={'24px'}>
                {t(LANG_TEXT.OPERATING_HOUR_SETTINGS)}
              </Typography>
            </Box>
            <Box className={classes.OperatingHourSettingsContent}>
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }} justifyContent="center" alignItems="center">
                {Week.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Card
                      day_of_week={item}
                      control={control}
                      currentSetting={currentSetting}
                      formData={formData}
                      setFormData={setFormData}
                      errors={errors}
                      setErrorState={(dayOfWeek: string, isError: boolean) => {
                        setErrors((prevErrors: any) => ({
                          ...prevErrors,
                          [dayOfWeek]: isError,
                        }));
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
          <Button
            id="settings"
            fullWidth={true}
            title={t(LANG_TEXT.SAVE)}
            sxTextStyle={{ fontSize: '14px', fontWeight: '600', lineHeight: '20px', color: '#ffffff' }}
            buttonStyle={buttonStyle}
            boxStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          />
          <Toast
            content={toast.current?.content}
            variant={toast.current?.type}
            open={openToast}
            onClose={() => {
              setOpenToast(false);
            }}
          />
        </form>
      )}
    </Box>
  );
}

export default Settings;
